// The value a saved-filter condition row stores, given the field the user chose (FilterForm's filter2)
// and what they picked or typed for it (filter4).
//
// FilterForm used to work this out twice. add() looked a picked option up by the field's dbNameField
// when it had one; edit() never did, so editing a condition on a List field whose dbNameField differs
// from its dbField left the row with no value - Enquiries Branch (dbField mbpBranchCode, dbNameField
// branchCode) on TEST 2026-09-14 - and saving would store a blank condition. Both now call this.
//
//   field     the db_view_fields row (fieldType, dbField, dbNameField, filterAllowStartWith)
//   picked    a dropdown option object, or the typed value
//   tempDate  the typed date when a Date field's modifier is "custom"
//   filter4Type  the input type FilterForm chose for a typed value
export function conditionValueFor(field, picked, { tempDate, filter4Type } = {}) {
  if (picked instanceof Object) {
    if (field.fieldType === 'Date') {
      return picked.dateModifierFunc === 'custom' ? tempDate : picked.dateModifierFunc
    }
    if (field.fieldType === 'Yes/No') {
      return picked.parentFlag
    }
    if (field.dbNameField) {
      return picked[field.dbNameField]
    }
    const segments = field.dbField.split('.')
    return picked[segments[segments.length - 1]]
  }

  if (
    ['String', 'Number', 'Currency', 'Time'].includes(filter4Type) ||
    (field.filterAllowStartWith && typeof picked === 'string')
  ) {
    return picked
  }

  return undefined
}
